// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import ButtonGroupItem from './c_ButtonGroupItem';

// js utilities
import _ from 'lodash';

import {validateField} from '../../../modelValidator';


export default class ButtonGroup extends Component {

  static propTypes = {
      defaultValue: PropTypes.array,
      value: PropTypes.array,
      id: PropTypes.any,
      disabled: PropTypes.bool,
      showAdd: PropTypes.bool,
      menuItems: PropTypes.array.isRequired,
      visibleItems: PropTypes.array,
      validation: PropTypes.object,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onErrorChange: PropTypes.func
  }

  state = {
    additionalItems: this.props.value || [],
    editable: false,
    addText: '',
    errors: []
  }

  componentWillMount() {
    const initVal = this.props.hasOwnProperty('value') ? this.props.value : this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;
    this.validate(initVal);
  }

  componentWillReceiveProps(nextProps) {
    if(`${this.props.value}` !== `${nextProps.value}`) {
      this.validate(nextProps.value, {
        additionalItems: _.union(this.state.additionalItems, nextProps.value)
      });
    }
  }

  componentWillUnmount() {
    if(this.state.errors.length && this.props.onErrorChange) {
      this.props.onErrorChange(-1);
    }
  }

  onChange(passedValue, event) {
    const value = this.props.value.slice();
    const index = value.indexOf(passedValue);
    if (index < 0) {
      value.push(passedValue);
    }
    else if(index > -1) {
      value.splice(index, 1);
    }

    // handle uncontrolled component validation update
    if(!this.props.hasOwnProperty('value')) {
      this.validate(value, {
        value
      });
    }

    if (this.props.onChange) {
      if (passedValue === 'None') {
        (value.length) ? this.props.onChange(event, ["None"]) : this.props.onChange(null, []);
      } else {
        this.props.onChange(event, value);
      }
    }
    if(this.props.onBlur) {
      this.props.onBlur(event, value);
    }
  }

  onEdit() {
    this.setState({editable:true});
  }

  onAdd(event) {
    if (event.key === 'Enter') {
      if (event.target.value) {
        // Remove . since it's not allowed for custom skills.
        event.target.value = event.target.value.replace(/\./g, '');
        const newVal = event.target.value;
        this.setState({
          editable: false,
          addText: ''
        }, () => this.onChange(newVal, null));
        this.refs.addText.blur();
      } else if (!event.target.value) {
        this.setState({addText: ''});
        this.refs.addText.blur();
      }
    }
  }

  onBlur(event) {
    if (!event.target.value) {
      this.setState({editable:false});
    }
    else {
      // Remove . since it's not allowed for custom skills.
      event.target.value = event.target.value.replace(/\./g, '');
      const newVal = event.target.value;
      this.setState({
        editable: false,
        addText: ''
      }, () => this.onChange(newVal, null));
      this.refs.addText.blur();
    }
  }

  updateText(event) {
    this.setState({...this.state, addText: event.target.value});
  }

  validate = (value, mergeObj) => {
    if(this.props.validation) {
      const errorsObj = {
        errors: validateField(value, this.props.validation)
      };
      if(errorsObj.errors.length !== this.state.errors.length) {
        if(this.props.onErrorChange) {
          this.props.onErrorChange(errorsObj.errors.length > this.state.errors ? 1 : -1);
        }
        this.setState(_.assign(this.state, errorsObj, mergeObj || {}));
      } else if (_.size(mergeObj)) {
        this.setState(_.assign(this.state, mergeObj));
      }
    } else if (_.size(mergeObj)) {
      this.setState(_.assign(this.state, mergeObj));
    }
  }

  render() {
    const items = _.chain(this.props.menuItems)
      .reduce((prev, curr) => {
        prev.push(_.get(curr, 'primaryText', curr));
        return prev;
      }, [])
      .union(this.state.additionalItems)
      .value();

    const hasNone = this.props.value.includes('None');

    const SHOW_ADD_DEFAULT = true;
    const showAdd = this.props.showAdd === undefined ? SHOW_ADD_DEFAULT : this.props.showAdd;

    if(hasNone) {
      items.length = 1;
    }
    return (
      <div className='button-group-container-wrapper'>
        <ul className='button-group-container'>
        {
          items.map((val, index) => {
            return (
              <ButtonGroupItem key={index}
                               value={val}
                               visible={_.isNil(this.props.visibleItems) || this.props.visibleItems.includes(val)}
                               selected={this.props.value.includes(val)}
                               onClick={this.onChange.bind(this, val)}/>
            );
          })
        }

        {
          !hasNone && showAdd &&
          <li
            className='button-group-item add'
            data-id='ADD'
            onMouseDown={!this.state.editable && this.onEdit.bind(this) || null}>
            {
              <input className='adding-button-group-item'
                placeholder={!this.state.editable && 'ADD' || ''}
                type='text'
                name='newItem'
                ref='addText'
                maxLength='48'
                value={this.state.addText}
                onChange={::this.updateText}
                onBlur={::this.onBlur}
                onKeyUp={this.onAdd.bind(this)}/>
              }
            </li>
        }
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_ButtonGroup/index.js